import React from 'react'

import BootstrapContainer from '@lyrahealth-inc/ui-core/lib/molecules/layouts/bootstrapContainer/BootstrapContainer'
import CardSmall from '@lyrahealth-inc/ui-core/lib/molecules/layouts/cardSmall/CardSmall'

import styles from './notFoundRoute.module.scss'

export default () => (
  <BootstrapContainer>
    <CardSmall>
      <div className={styles['notFound-container']}>
        <h1>Page not found.</h1>
        <p>The URL you are trying to access doesn&apos;t exist.</p>
      </div>
    </CardSmall>
  </BootstrapContainer>
)
